import {
    IWebsiteScorecardConfig, IWebsiteScorecardCategoryConfig } from '../../../../_shared/models/models-index';
import * as constants from '../../../../_shared/constants/constants';

export class WebsiteScorecardConfig implements IWebsiteScorecardConfig {
    public reportTitle = 'Website Scorecard';
    public scorecards: IWebsiteScorecardCategoryConfig[] = [
        {
            category: 'Volume',
            billboards: [
                {
                    title: 'Visits',
                    subtitle: '',
                    iconClass: 'fa-users fa-primary',
                    reverseMetric: false,
                    metricCurrentPropertyName: 'totalVisits',
                    metricMOMPropertyName: 'totalVisitsMOM',
                    metricYOYPropertyName: 'totalVisitsYOY',
                    metricPreviousMonthPropertyName: 'totalVisitsPreviousMonth',
                    metricPreviousMTDPropertyName: 'totalVisitsPreviousMTD',
                    metricPreviousYearPropertyName: 'totalVisitsPreviousYear',
                    footerLeftLabel: 'MOM',
                    footerRightLabel: 'YOY',
                    footerMetricFormatKey: constants.formatKeys.percentageTwoDecimals,
                    trendArrowDrivingPropertyName: 'totalVisitsMOM',
                    metricFormatKey: constants.formatKeys.abbreviatedLocaleString,
                    subtitleMetricFormatKey: constants.formatKeys.abbreviatedLocaleString,
                    helpTextKey: 'WebsiteScorecardTotalVisitsHelp',
                    helpTextTitle: 'Visits',
                    scoreCardCategory: 'Volume'
                },
                {
                    title: 'Unique Visits',
                    subtitle: '',
                    iconClass: 'fa-user fa-primary',
                    reverseMetric: false,
                    metricCurrentPropertyName: 'uniqueVisits',
                    metricMOMPropertyName: 'uniqueVisitsMOM',
                    metricYOYPropertyName: 'uniqueVisitsYOY',
                    metricPreviousMonthPropertyName: 'uniqueVisitsPreviousMonth',
                    metricPreviousMTDPropertyName: 'uniqueVisitsPreviousMTD',
                    metricPreviousYearPropertyName: 'uniqueVisitsPreviousYear',
                    footerLeftLabel: 'MOM',
                    footerRightLabel: 'YOY',
                    footerMetricFormatKey: constants.formatKeys.percentageTwoDecimals,
                    trendArrowDrivingPropertyName: 'uniqueVisitsMOM',
                    metricFormatKey: constants.formatKeys.abbreviatedLocaleString,
                    subtitleMetricFormatKey: constants.formatKeys.abbreviatedLocaleString,
                    helpTextKey: 'WebsiteScorecardUniqueVisitsHelp',
                    helpTextTitle: 'Unique Visits',
                    scoreCardCategory: 'Volume'
                },
                {
                    title: 'Page Views',
                    subtitle: '',
                    iconClass: 'fa-file fa-primary',
                    reverseMetric: false,
                    metricCurrentPropertyName: 'pageViews',
                    metricMOMPropertyName: 'pageViewsMOM',
                    metricYOYPropertyName: 'pageViewsYOY',
                    metricPreviousMonthPropertyName: 'pageViewsPreviousMonth',
                    metricPreviousMTDPropertyName: 'pageViewsPreviousMTD',
                    metricPreviousYearPropertyName: 'pageViewsPreviousYear',
                    footerLeftLabel: 'MOM',
                    footerRightLabel: 'YOY',
                    footerMetricFormatKey: constants.formatKeys.percentageTwoDecimals,
                    trendArrowDrivingPropertyName: 'pageViewsMOM',
                    metricFormatKey: constants.formatKeys.abbreviatedLocaleString,
                    subtitleMetricFormatKey: constants.formatKeys.abbreviatedLocaleString,
                    helpTextKey: 'WebsiteScorecardPageViewsHelp',
                    helpTextTitle: 'Page Views',
                    scoreCardCategory: 'Volume'
                }
            ],
        },
        {
            category: 'Engagements',
            billboards: [
              
                {
                    title: 'Engagement Rate',
                    subtitle: '',
                    iconClass: 'fa-user-plus fa-primary',
                    reverseMetric: false,
                    metricCurrentPropertyName: 'engagementRate',
                    metricMOMPropertyName: 'engagementRateMOM',
                    metricYOYPropertyName: 'engagementRateYOY',
                    metricPreviousMonthPropertyName: 'engagementRatePreviousMonth',
                    metricPreviousMTDPropertyName: 'engagementRatePreviousMTD',
                    metricPreviousYearPropertyName: 'engagementRatePreviousYear',
                    footerLeftLabel: 'MOM',
                    footerRightLabel: 'YOY',
                    footerMetricFormatKey: constants.formatKeys.percentageTwoDecimals,
                    subtitleMetricFormatKey: constants.formatKeys.percentageNoDecimals,
                    trendArrowDrivingPropertyName: 'engagementRateMOM',
                    metricFormatKey: constants.formatKeys.percentageTwoDecimals,
                    helpTextKey: 'WebsiteScorecardEngagementRateHelp',
                    helpTextTitle: 'Engagement Rate',
                    scoreCardCategory: 'Engagements'
                },
                {
                    title: 'Time On Site',
                    subtitle: '',
                    iconClass: 'fa-clock-o fa-primary',
                    reverseMetric: false,
                    metricCurrentPropertyName: 'averageTimeOnSite',
                    metricMOMPropertyName: 'averageTimeOnSiteMOM',
                    metricYOYPropertyName: 'averageTimeOnSiteYOY',
                    metricPreviousMonthPropertyName: 'averageTimeOnSitePreviousMonth',
                    metricPreviousMTDPropertyName: 'averageTimeOnSitePreviousMTD',
                    metricPreviousYearPropertyName: 'averageTimeOnSitePreviousYear',
                    footerLeftLabel: 'MOM',
                    footerRightLabel: 'YOY',
                    footerMetricFormatKey: constants.formatKeys.percentageTwoDecimals,
                    trendArrowDrivingPropertyName: 'averageTimeOnSiteMOM',
                    metricFormatKey: constants.formatKeys.minutesTimeStringFromSeconds,
                    subtitleMetricFormatKey: constants.formatKeys.minutesTimeStringFromSeconds,
                    helpTextKey: 'WebsiteScorecardTimeOnSiteHelp',
                    helpTextTitle: 'Time On Site',
                    scoreCardCategory: 'Engagements'
                },
                {
                    title: 'VDP Views',
                    subtitle: '',
                    iconClass: 'fa-file fa-primary',
                    reverseMetric: false,
                    metricCurrentPropertyName: 'totalInventoryDetailViews',
                    metricMOMPropertyName: 'totalInventoryDetailViewsMOM',
                    metricYOYPropertyName: 'totalInventoryDetailViewsYOY',
                    metricPreviousMonthPropertyName: 'totalInventoryDetailViewsPreviousMonth',
                    metricPreviousMTDPropertyName: 'totalInventoryDetailViewsPreviousMTD',
                    metricPreviousYearPropertyName: 'totalInventoryDetailViewsPreviousYear',
                    footerLeftLabel: 'MOM',
                    footerRightLabel: 'YOY',
                    footerMetricFormatKey: constants.formatKeys.percentageTwoDecimals,
                    trendArrowDrivingPropertyName: 'totalInventoryDetailViewsMOM',
                    metricFormatKey: constants.formatKeys.abbreviatedLocaleString,
                    subtitleMetricFormatKey: constants.formatKeys.abbreviatedLocaleString,
                    helpTextKey: 'WebsiteScorecardVDPViewsHelp',
                    helpTextTitle: 'VDP Views',
                    scoreCardCategory: 'Engagements'
                },
                {
                    title: 'Bounce Rate',
                    subtitle: '',
                    iconClass: 'fa-percent fa-primary',
                    reverseMetric: true,
                    metricCurrentPropertyName: 'bounceRate',
                    metricMOMPropertyName: 'bounceRateMOM',
                    metricYOYPropertyName: 'bounceRateYOY',
                    metricPreviousMonthPropertyName: 'bounceRatePreviousMonth',
                    metricPreviousMTDPropertyName: 'bounceRatePreviousMTD',
                    metricPreviousYearPropertyName: 'bounceRatePreviousYear',
                    footerLeftLabel: 'MOM',
                    footerRightLabel: 'YOY',
                    footerMetricFormatKey: constants.formatKeys.percentageTwoDecimals,
                    subtitleMetricFormatKey: constants.formatKeys.percentageNoDecimals,
                    trendArrowDrivingPropertyName: 'bounceRateMOM',
                    metricFormatKey: constants.formatKeys.percentageTwoDecimals,
                    helpTextKey: 'WebsiteScorecardBounceRateHelp',
                    helpTextTitle: 'Bounce Rate',
                    scoreCardCategory: 'Engagements'
                },
            ]
        },
        {
            category: 'Actions',
            billboards: [
                {
                    title: 'Action Rate',
                    subtitle: '',
                    iconClass: 'fa-percent fa-primary',
                    reverseMetric: false,
                    metricCurrentPropertyName: 'actionRate',
                    metricMOMPropertyName: 'actionRateMOM',
                    metricYOYPropertyName: 'actionRateYOY',
                    metricPreviousMonthPropertyName: 'actionRatePreviousMonth',
                    metricPreviousMTDPropertyName: 'actionRatePreviousMTD',
                    metricPreviousYearPropertyName: 'actionRatePreviousYear',
                    footerLeftLabel: 'MOM',
                    footerRightLabel: 'YOY',
                    footerMetricFormatKey: constants.formatKeys.percentageTwoDecimals,
                    subtitleMetricFormatKey: constants.formatKeys.percentageNoDecimals,
                    trendArrowDrivingPropertyName: 'actionRateMOM',
                    metricFormatKey: constants.formatKeys.percentageTwoDecimals,
                    helpTextKey: 'WebsiteScorecardActionRateHelp',
                    helpTextTitle: 'Action Rate',
                    scoreCardCategory: 'Actions'
                },
                {
                    title: 'Form Submissions',
                    subtitle: '',
                    iconClass: 'fa-file-text fa-primary',
                    reverseMetric: false,
                    metricCurrentPropertyName: 'formSubmissions',
                    metricMOMPropertyName: 'formSubmissionsMOM',
                    metricYOYPropertyName: 'formSubmissionsYOY',
                    metricPreviousMonthPropertyName: 'formSubmissionsPreviousMonth',
                    metricPreviousMTDPropertyName: 'formSubmissionsPreviousMTD',
                    metricPreviousYearPropertyName: 'formSubmissionsPreviousYear',
                    footerLeftLabel: 'MOM',
                    footerRightLabel: 'YOY',
                    footerMetricFormatKey: constants.formatKeys.percentageTwoDecimals,
                    trendArrowDrivingPropertyName: 'formSubmissionsMOM',
                    metricFormatKey: constants.formatKeys.abbreviatedLocaleString,
                    subtitleMetricFormatKey: constants.formatKeys.abbreviatedLocaleString,
                    helpTextKey: 'WebsiteScorecardFormSubmissionsHelp',
                    helpTextTitle: 'Form Submissions',
                    scoreCardCategory: 'Actions'
                },
                {
                    title: 'Click to Calls',
                    subtitle: '',
                    iconClass: 'fa-phone fa-primary',
                    reverseMetric: false,
                    metricCurrentPropertyName: 'clickToCalls',
                    metricMOMPropertyName: 'clickToCallsMOM',
                    metricYOYPropertyName: 'clickToCallsYOY',
                    metricPreviousMonthPropertyName: 'clickToCallsPreviousMonth',
                    metricPreviousMTDPropertyName: 'clickToCallsPreviousMTD',
                    metricPreviousYearPropertyName: 'clickToCallsPreviousYear',
                    footerLeftLabel: 'MOM',
                    footerRightLabel: 'YOY',
                    footerMetricFormatKey: constants.formatKeys.percentageTwoDecimals,
                    trendArrowDrivingPropertyName: 'clickToCallsMOM',
                    metricFormatKey: constants.formatKeys.abbreviatedLocaleString,
                    subtitleMetricFormatKey: constants.formatKeys.abbreviatedLocaleString,
                    helpTextKey: 'WebsiteScorecardClickToCallsHelp',
                    helpTextTitle: 'Click to Calls',
                    scoreCardCategory: 'Actions'
                },
                {
                    title: 'Phone Calls',
                    subtitle: '',
                    iconClass: 'fa-phone fa-primary',
                    reverseMetric: false,
                    metricCurrentPropertyName: 'phoneCalls',
                    metricMOMPropertyName: 'phoneCallsMOM',
                    metricYOYPropertyName: 'phoneCallsYOY',
                    metricPreviousMonthPropertyName: 'phoneCallsPreviousMonth',
                    metricPreviousMTDPropertyName: 'phoneCallsPreviousMTD',
                    metricPreviousYearPropertyName: 'phoneCallsPreviousYear',
                    footerLeftLabel: 'MOM',
                    footerRightLabel: 'YOY',
                    footerMetricFormatKey: constants.formatKeys.percentageTwoDecimals,
                    trendArrowDrivingPropertyName: 'phoneCallsMOM',
                    metricFormatKey: constants.formatKeys.abbreviatedLocaleString,
                    subtitleMetricFormatKey: constants.formatKeys.abbreviatedLocaleString,
                    helpTextKey: 'WebsiteScorecardPhoneCallsHelp',
                    helpTextTitle: 'Phone Calls',
                    scoreCardCategory: 'Actions'
                },
            ]
        }
    ];
}
